import PropTypes from "prop-types";
import { useEffect } from "react";
import { useGetCourseByIdQuery } from "../../store/services/university-service";
import { APP_URL } from "../../config";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

CoursePreview.propTypes = {
    courseId: PropTypes.string.isRequired,
}

export default function CoursePreview(props) {
    const { courseId } = props;
    const { user } = useSelector((state) => state.auth);

    // Set API endpoint for SCORM runtime (loaded in wrapper)
    useEffect(() => {
        window.REACT_APP_RESPONSE_API_URL = process.env.REACT_APP_RESPONSE_API_URL;
    }, []);

    // Explicitly encode to ensure consistent behavior across browsers
    const encodedCourseId = encodeURIComponent(courseId);

    const { data: courseData, isLoading: courseLoading, error: courseError } = useGetCourseByIdQuery({
        courseId: encodedCourseId,
        includes: '',
    });

    // Generate appropriate course URL based on course type
    const getCourseUrl = () => {
        if (!courseData?.courseContentPath) return '';

        const isLmsCourse = courseData.isLms === true;
        const parentOrigin = window.location.origin;

        if (isLmsCourse) {
            // For LMS courses, use the SCORM wrapper
            const absoluteCourseUrl = `${APP_URL}/${courseData.courseContentPath}`;
            return `/scorm-wrapper.html?` +
                `courseUrl=${encodeURIComponent(absoluteCourseUrl)}&` +
                `emailAddress=${encodeURIComponent(user?.email || 'preview@example.com')}&` +
                `courseIdentifier=${encodeURIComponent(courseData.courseName)}&` +
                `courseType=${courseData.isXApi ? 'xapi' : 'scorm'}`;
        } else {
            // For standard courses, use the direct URL with query parameters
            return `${APP_URL}/${courseData.courseContentPath}?` +
                `useremailaddress=${encodeURIComponent(user?.email || 'preview@example.com')}&` +
                `courseidentifier=${encodeURIComponent(courseData.courseName)}&` +
                `parentorigin=${encodeURIComponent(parentOrigin)}`;
        }
    };

    const courseURL = getCourseUrl();
    const isLmsCourse = courseData?.isLms === true;

    if (courseLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    if (courseError) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography color="error">Error loading course preview</Typography>
            </Box>
        );
    }

    if (courseData && courseURL) {
        return (
            <Box sx={{ width: '100%', height: '100%' }}>
                <iframe
                    src={courseURL}
                    title={`Preview: ${courseData.courseName}`}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    allow={isLmsCourse ? "autoplay; fullscreen" : undefined}
                    allowFullScreen={isLmsCourse}
                />
            </Box>
        );
    }

    return null;
}